import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";

import Button from "@material-ui/core/Button";

import { ValidationForm } from "shared/validator";
import { Input } from "shared/wrapper";

@observer
class ChangePasswordPanel extends Component {
  //===========================================================================
  @observable pw = "";
  @observable npw = "";
  @observable npw2 = "";
  //===========================================================================

  render() {
    return (
      <div className="full-box">
        <div className="pwc-box">
          <ValidationForm onSubmit={this.changePassword}>
            <div className="box-1" />
            <div className="box-2">
              <Input
                required
                minLength={5}
                maxLength={20}
                name="pw"
                label="기존 비밀번호"
                type="password"
                value={this.pw}
                onChangeInput={this.changeInput}
              />
              <br />
              <Input
                ref={ref => (this._npw = ref)}
                required
                minLength={5}
                maxLength={20}
                name="npw"
                label="신규 비밀번호"
                type="password"
                value={this.npw}
                onChangeInput={this.changeInput}
              />
              <br />
              <Input
                required
                minLength={5}
                maxLength={20}
                isEqual={() => this._npw}
                name="npw2"
                label="신규 비밀번호 확인"
                type="password"
                value={this.npw2}
                onChangeInput={this.changeInput}
              />
            </div>
            <div className="box-3">
              <Button type="submit" variant="outlined" color="primary">
                비밀번호 변경하기
              </Button>
            </div>
          </ValidationForm>
        </div>
      </div>
    );
  }
  //===========================================================================
  /**
   * 입력값 설정
   */
  @action
  changeInput = e => {
    const { name, value } = e.target;
    this[name] = value;
  };
  //===========================================================================
  /**
   * 비밀번호 변경
   */
  changePassword = () => {
    const { authStore } = this.props.rootStore;
    authStore.changePassword({
      pw: this.pw,
      npw: this.npw,
      npw2: this.npw2
    });
  };
  //===========================================================================
}

export default ChangePasswordPanel;
